import MerchantPage from '@/pages/general'
import MerchantHome from '@/pages/general/Home'
import General from './general.js'
import BookingEngine from './hotel/BookingEngine.js'
import Concierge from './hotel/Concierge.js'
import Upselling from './hotel/Upselling.js'
import Ticket from './Ticket.js'
import Restaurant from './Restaurant.js'
import config from '../../../config/index.js'
const emptyView = {template: '<router-view></router-view>'}

let childPath = [
  ...General,
  ...BookingEngine,
  ...Concierge,
  Upselling,
  ...Ticket,
  ...Restaurant,
  {
    path: '',
    name: 'MerchantHome',
    component: MerchantHome,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
      need_reload_merchant: true,
      no_loading: true,
      is_special_merchant: true
    }
  }
]

const generateChildPath = () => {
  const prefix = window.IS_MERCHANT_CODE_HIDE ? '' : ':merchant_code'
  return childPath.map(route => {
    const newRoute = { ...route }
    newRoute.path = prefix ? `/${prefix}/${route.path}` : `/${route.path}`
    return newRoute;
  });
}

const generateChildPathh = generateChildPath();

export default [
  {
    path: '/',
    name: 'MerchantPageBase',
    component: MerchantPage,
    children: generateChildPathh
  },
  {
    path: "*",
    name: "NotFound",
    beforeEnter(to,from,next){
      if(!window.IS_MERCHANT_CODE_HIDE) next();
      
      const splittedPath = to.path.split("/")
      if(splittedPath.length > 2) next();
      if(splittedPath.length == 2) next({name:'MerchantPageBase'});
      const rest = splittedPath.slice(2);
      next(`/${rest.join('/')}`)
    },
    component: emptyView
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/index.js